/*
 * @Author: ausheng ausheng@foxmail.com
 * @Date: 2022-11-25 16:05:51
 * @LastEditors: ausheng ausheng@foxmail.com
 * @LastEditTime: 2022-11-27 13:45:55
 * @FilePath: \main\src\views\data-manage\helper\map.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export const techParametersMap = {
  turbineType: '机组',
  vendor: '生产厂商',
  diameter: '叶轮直径',
  ratedPower: '额定功率',
  wspdIn: '切入风速',
  wspdOut: '切出风速',
  ratedSpeed: '额定风速',
  //aliveSpeed: '50年一遇最大风速',
  wspd50year10min: '50年一遇10分钟平均最大风速（m/s）',
  wspd50year3sec: '50年一遇3s平均极限风速（m/s）',
  powerAdjustType: '功率调节方式',
  hubDirection:'风轮方向',
  securityLevel: 'IEC等级（风速）',
  turbulenceLever: 'IEC等级（湍流）',
  hubWeight: '塔筒重量',
  hubHeight: '塔筒高度',
  concreteQuantity: '基础混凝土体积',
  mixedPureLandLabel: '基础混凝土标号',
  baseLayerVolume: '基础垫层体积',
  baseLayerLabel: '基础垫层标号',
  foundationReinforcement: '基础钢筋用量',
  foundationExcavationVolume: '基础挖方量',
  backFill: '基础填方量',
  mainReinforcementModel: '基础钢筋型号',
  turbineUnitPrice: '风机单价',
  towerUnitPrice: '塔架单价',
  baseUnitPrice: '基础单价',
  alternatorType:'发电机型式',
  alternatorPower:'电机功率（KW）',
  ratedHz:'额定频率（Hz）',
  ratedVol:'额定电压（v）',
  airBrakingMode:'空气制动方式',
  mechanicalBrakingMode:'机械制动方式',
  sweepArea:'扫风面积（m2）',
  bladeCount:'叶片数',
  curveDensity:'功率曲线年平均空气密度（kg/m3）',
  designWspd:'设计年平均风速（m/s）',
  designAngle:'设计入流角',
  designShear:'设计风切变幂指数',
  engineWeight:'机舱重量（t）',
  bladeWeight:'轮毅+叶片重量（t）',

};

export const techParametersUnit = {
  turbineType: '',
  vendor: '',
  diameter: 'm',
  ratedPower: 'kW',
  wspdIn: 'm/s',
  wspdOut: 'm/s',
  ratedSpeed: 'm/s',
  aliveSpeed: 'm/s',
  securityLevel: '',
  turbulenceLever: '',
  hubWeight: 't',
  hubHeight: 'm',
  concreteQuantity: 'm³',
  mixedPureLandLabel: '',
  baseLayerVolume: 'm³',
  baseLayerLabel: '',
  foundationReinforcement: 't',
  foundationExcavationVolume: 'm³',
  backFill: 'm³',
  mainReinforcementModel: '',
  turbineUnitPrice: '元/kw',
  towerUnitPrice: '元/kw',
  baseUnitPrice: '元/kw'
};

export const nameParametersMap = {
  '机组':'turbineType',
  '生产厂商':'vendor',
  '叶轮直径':'diameter',
  '额定功率':'ratedPower',
  '切入风速':'wspdIn',
  '切出风速': 'wspdOut',
  '额定风速':'ratedSpeed',
  '50年一遇最大风速':'aliveSpeed',
  '50年一遇10分钟平均最大风速（m/s）':'wspd50year10min',
  '50年一遇3s平均极限风速（m/s）':'wspd50year3sec',
  '功率调节方式':'powerAdjustType',
  '风轮方向':'hubDirection',
  '发电机型式':'alternatorType',
  '电机功率（KW）':'alternatorPower',
  '额定频率（Hz）':'ratedHz',
  '额定电压（v）':'ratedVol',
  '空气制动方式':'airBrakingMode',
  '机械制动方式':'mechanicalBrakingMode',
  'IEC等级（风速）':'securityLevel',
  'IEC等级（湍流）': 'turbulenceLever',
  '塔筒重量':'hubWeight',
  '塔筒高度':'hubHeight',
  '基础混凝土体积':'concreteQuantity',
  '基础混凝土标号':'mixedPureLandLabel',
  '基础垫层体积':'baseLayerVolume',
  '基础垫层标号':'baseLayerLabel',
  '基础钢筋用量':'foundationReinforcement',
  '基础挖方量':'foundationExcavationVolume',
  '基础填方量':'backFill',
  '基础钢筋型号':'mainReinforcementModel',
  '风机单价':'turbineUnitPrice',
  '塔架单价':'towerUnitPrice',
  '基础单价':'baseUnitPrice',
  '扫风面积（m2）':'sweepArea',
  '叶片数':'bladeCount',
  '功率曲线年平均空气密度（kg/m3）':'curveDensity',
  '设计年平均风速（m/s）':'designWspd',
  '设计入流角':'designAngle',
  '设计风切变幂指数':'designShear',
  '设计入流角':'designAngle',
  '机舱重量（t）':'engineWeight',
  '轮毅+叶片重量（t）':'bladeWeight',
};
